import {fetchPost, generateEndpoint} from "../../../utils/request";

export const createBsrsSurvey = async({ age, gender, score, answers }) => {
  const url = `${generateEndpoint('createBsrsSurvey')}`
  return fetchPost(url, null, { age, gender, score, answers })
}